/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { DepositIcon } from '../Icons'
import { Typography } from '../Typography'

interface WinNoticeProps {
  className?: string
  title: string
  ratio?: number
  amount?: number
  color?: 'green' | 'red' | 'gold3' | 'gold1'
}

const WinNotice: FC<WinNoticeProps> = observer(
  ({ className, title, ratio, amount, color = 'green' }) => {
    let sign = ''
    if (color === 'green') {
      sign = '+'
    } else if (color === 'red') {
      sign = '-'
    }

    return (
      <div className={className} data-cy="win-notice">
        <Typography variant="gameInfo" color={color}>
          {title}
        </Typography>
        {ratio && (
          <Typography variant="titleBig" color="white">
            {ratio}:1
          </Typography>
        )}
        {amount !== undefined && (
          <Typography
            variant="win"
            color={color}
            as="div"
            css={css`
              display: flex;
              align-items: center;
              justify-content: right;
            `}>
            {sign}
            {amount}&nbsp;
            <DepositIcon size="8px" color={color} />
          </Typography>
        )}
      </div>
    )
  }
)

export default WinNotice
